import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  converters,
} from '../converters/index.js';

export const narrative_event_refs = {
  document: ({
    workspace_id,
    project_id,
    narrative_event_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'narrative_events',
      narrative_event_id,
    ].join('/');
    return doc(db, path).withConverter(converters.narrative_events);
  },
  collection: ({
    workspace_id,
    project_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'narrative_events',
    ].join('/');
    return collection(db, path).withConverter(converters.narrative_events);
  },
};


